import { render, staticRenderFns } from "./ClientTaskSelect.vue?vue&type=template&id=7a056fae"
import script from "./ClientTaskSelect.vue?vue&type=script&lang=js"
export * from "./ClientTaskSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports